import { useEffect } from 'react';
import CreditUsageListTable from '../CreditUsageListTable';
import {
  useCreditUsageList,
  useFetchCompanyCreditUsageList,
} from '../../../../store/CreditsManagement/creditsManagementHooks';

interface CreditUsageListTableContainerProps {
  id: number;
  isPersonal?: boolean;
}

const CreditUsageListTableContainer = (
  props: CreditUsageListTableContainerProps
) => {
  const usageList = useCreditUsageList();
  const fetchUsageList = useFetchCompanyCreditUsageList();

  useEffect(() => {
    fetchUsageList(props.id).finally();
  }, [props.id]);

  return (
    <div>
      <CreditUsageListTable usageList={usageList} />
    </div>
  );
};

export default CreditUsageListTableContainer;
